import toggleVisibility from '../toggleVisibility';

const updateSelectedVariant = ({
  variant,
  variantInventory = [],
  variantStock = [],
  variantLeadTimes = [],
  elements = {},
  form,
  strings = {}
}) => {
  const {
    productPreOrderMsg,
    productSoldInfo,
    productControls,
    productStockCount,
    productLeadTime,
    productLeadTimeWrapper,
    klaviyoBIS,
    atcButtonMsg
  } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !variant.available && !isPreOrder;
  const isAvailable = variant.available;
  const stockInfo = variantStock.find(v => v.id === variant.id);
  const isInventoryTracked = stockInfo?.inventory_management != null;
  // variantLeadTimes is only ever populated when the "show variant lead
  // time" theme setting is on (see product-variant-data.liquid), so
  // hasLeadTime is naturally false whenever that setting is off - this is
  // the single source of truth both the lead time row and the Klaviyo
  // back-in-stock toggle below key off, so they can't drift out of sync.
  const leadTimeInfo = variantLeadTimes.find(v => v.id === variant.id);
  const hasLeadTime = Boolean(leadTimeInfo?.lead_time);

  if (productPreOrderMsg) toggleVisibility(productPreOrderMsg, isPreOrder);
  if (productSoldInfo) toggleVisibility(productSoldInfo, !isPreOrder && isAvailable);
  // Only stands in for back-in-stock capture when this specific variant has
  // no lead time to show instead - not gated on the theme setting itself,
  // since that's global and this needs to be a per-variant decision.
  if (klaviyoBIS) toggleVisibility(klaviyoBIS, isSoldOut && !hasLeadTime);
  if (productControls) toggleVisibility(productControls, isAvailable);

  if (productStockCount) {
    productStockCount.textContent = stockInfo?.inventory_quantity ?? '';
    toggleVisibility(productStockCount, isInventoryTracked, 'inline');
  }

  // The whole "Out of Stock" row (icon, label, and lead time) must never
  // show for an available variant - only the lead time text within it is
  // additionally conditional on that variant actually having one set.
  if (productLeadTime) toggleVisibility(productLeadTime, !isAvailable, 'flex');

  if (productLeadTimeWrapper) {
    // Only the value span's text is replaced here - the <p> itself also
    // carries the locale-driven "Production Time:" prefix as a sibling text
    // node, which productLeadTimeWrapper.textContent = ... would otherwise
    // wipe out along with this span's own bold styling.
    const leadTimeValueEl = productLeadTimeWrapper.querySelector('[data-product-lead-time-value]');
    if (leadTimeValueEl) leadTimeValueEl.textContent = leadTimeInfo?.lead_time ?? '';
    toggleVisibility(productLeadTimeWrapper, hasLeadTime, 'block');
  }

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    atcButtonMsg.textContent = getAtcBtnText();
  }

  if (!form) return;

  const options = [variant.option1, variant.option2, variant.option3];

  options.forEach((optionValue, index) => {
    if (!optionValue) return;
    const optionSelectedEl = form.querySelector(`[data-option-${index + 1}] [data-option-selected]`);
    if (!optionSelectedEl) return;
    optionSelectedEl.textContent = optionValue;
  });

};

export default updateSelectedVariant;
